import { useState, useRef, useEffect } from "react";
interface props {
  heading?: string;
  subheading?: string;
  children?: React.ReactNode;
}
const HeadingComponent = ({ heading, subheading, children }: props) => {
  return (
    <>
      <div className="mt-4 lg:mt-0 w-full px-customPaddingMobile lg:px-customPadding  2xl:px-0 2xl:w-[1340px] 2xl:mx-auto pb-[50px] lg:pb-0 lg:h-[437px] pt-2 lg:pt-[124px] ">
        <p className="text-center font-spaceGrotesk font-normal text-mobile-h1 lg:text-web-h2 leading-[38px] lg:leading-[61px] text-brand-textBlack">
          {" "}
          {heading}
        </p>
        <p className="mt-6 text-center font-openSans font-normal text-mobile-body-sm lg:text-web-subheading leading-4 lg:leading-6 text-brand-textGrey">
          {subheading}
        </p>
        {children}
      </div>
    </>
  );
};

export default HeadingComponent;
